/* Component Dependencies */
var _ = require('lodash');
var yourDetailsTemplate = require('templates/yourDetails.hbs');
var yourDetailsTemplateAssociateModify = require('templates/yourDetails-associateModify.hbs');
var yourDetailsTemplateAssociate = require('templates/yourDetails-associate.hbs');
var AriesComponent = require('libs/aries-component');
var deserialize = require('reservation_libs/deserialize');
var ResponsiveWidgetHandler = require('reservation_libs/responsive-widget-handler');
var Constants = require('libs/constants');
var Popup = require('libs/popup');
var PubSub = require('libs/pub-sub');

ResponsiveWidgetHandler.create({

  type: 'yourDetails',
  template: {
    'yourDetails': yourDetailsTemplate,
    'yourDetails-associateModify' :  yourDetailsTemplateAssociateModify,
    'yourDetails-associate': yourDetailsTemplateAssociate
  },
  events: {
    'click .js-your-detail-submit-form button[type="submit"]': 'handleSubmitForm'
  },
  subscribe: {
    'OPEN_GUEST_INFO': 'openGuestInfo',
    'FROM_IFRAME_SET_CC_DATA': 'setCCFrameData',
    'FROM_IFRAME_REGISTER_POP_UP': 'registerCCPopUp',
    'WHY_WE_ASK_POPUP_TRIGGERER': 'creditCardModalPopUp'
  },

  bindEvents: function($) {
    var _self= this;
    this.initResponsiveUtils();
    this.isAssociate = this.$el.data("is-associate");
    this.isModifiedRoom = this.$el.hasClass('tile-your-details-modify');
    this.$activeAccordion = this.$el.find('.l-accordion-content.l-display-block');
    _self.$el.find('.js-toggle-item').on('click', function(event) {
      _self.toggleItemHandler(event);
      _self.pubsub.publish('SALES_FORCE_RECORDING_HANDLER', [Constants.SALES_FORCE_EVENT.ACTION_TYPE.RESUME]);
    });
    this.$el.on("click", ".js-cancel-btn", function(event){
      event.preventDefault();
      _self.triggerWidgetCollapse.call(_self, $(this).closest('.js-target-container'), true, $(this).data('url'));
    });
    if(_self.$el.find('.js-tile-expanded')) {
      _self.$el.find('.js-tile-expanded').trigger('click');
    }
    this.$el.find('.js-accordion').on("click", ".l-toggle-list", this.triggerAccordionDisplay.bind(this));
    $(this.$el).trigger('GLOBAL_ELEMENTS_REINIT.mi-foundation');
    _self.pubsub.publish('SALES_FORCE_RECORDING_HANDLER', [Constants.SALES_FORCE_EVENT.ACTION_TYPE.RESUME]);

    //Scroll to Updated Room Section for Empower on review reservation change page
    if(this.isAssociate && this.isModifiedRoom) {
      var baseOffset = 0;
      baseOffset = $('#stickySummary').length ?  $('#stickySummary').outerHeight() : baseOffset;
      $('html, body').animate({scrollTop: _self.$el.offset().top - baseOffset - 20});
    }

  },

  openGuestInfo: function _openGuestInfo(confirmationNumber) {
    if(!confirmationNumber)
      return false;
    var _self = this,
        guestInfoToOpen;
    _self.$el.find('.js-confirmation-number').each(function() {
      if($(this).data('confirmation-number') === confirmationNumber)
        guestInfoToOpen = $(this);
    });
    if(!guestInfoToOpen)
      return false;
    if(guestInfoToOpen.find('.l-accordion-heading').attr('aria-expanded') === "false") {
      guestInfoToOpen.find('.l-toggle-list').trigger('click');
    }
    if(guestInfoToOpen.find('.js-toggle-item').eq(0).find('.js-icon-desktop').hasClass('t-icon-arrow-down')) {
      guestInfoToOpen.find('.js-toggle-item')[0].click();
    }
    return true;
  },
  
  /** This function is used to toggle the visibility of accordions.
   * It closes the active accordion and opens the clicked one.
   * @param  {Object} event Contains reference of click event
   */
  triggerAccordionDisplay: function(event){
    var currentAccordion = $(event.currentTarget).closest('.js-accordion');
    if(currentAccordion.find('.l-accordion-content').hasClass('l-display-block')){
      if(this.$activeAccordion.length){
        this.$activeAccordion.closest('.js-accordion').find('.l-toggle-list')[0].click();
      }
      this.$activeAccordion = currentAccordion.find('.l-accordion-content');
    } else {
      this.$activeAccordion = '';
    }
  },
  triggerWidgetCollapse: function($widgetContainer, isCancel, cancelURL){
    var toggleItem = $widgetContainer.closest('.js-layout-container').find('.js-toggle-item'),
      queryParamsJSON;
    if(!this.isTakeOverActive){
      $(window).scrollTop(this.$el.offset().top);
    }
    if(cancelURL) {
      queryParamsJSON = deserialize(toggleItem.data('url'));
      this.makeAjaxCall({
        method: 'POST',
        url: cancelURL,
        data: JSON.stringify({
          context: this.getExtendedComponentContext(queryParamsJSON),
          sessionToken: this.getSessionToken(),
          sourceURI: this.getSourceURI()
        }),
        contentType: 'application/json'
      });
      this.$activeContainer.data('error', false);
    }
    toggleItem[0].click();
    this.refresh();
    // Resume Sales Force Event On click of cancel Link
    var currentForm = $widgetContainer.closest('.js-layout-container').closest('.js-your-detail-submit-form');
    if(currentForm.hasClass('js-credit-card-form') && currentForm.hasClass('js-associate-form')) {
      _self.pubsub.publish('SALES_FORCE_RECORDING_HANDLER', [Constants.SALES_FORCE_EVENT.ACTION_TYPE.RESUME]);
    }
  },

  /**
   * This method registers the creditCard Popup from iframe
   * @method registerCCPopUp
   * @returns {boolean} true when the function executes successfully
   */
  registerCCPopUp: function _registerCCPopUp(popUpConfig) {
    new Popup(popUpConfig).register();
    return true;
  },

  /**
   * @param  {Event} event : Contains information of the submit event
   * This function submits the form on click of Submit Button
   */
  handleSubmitForm: function(event){
    this.$form = $(event.currentTarget).closest('.js-your-detail-submit-form');
    this.$form.find('button[type="submit"]').prop('disabled', true);
    if(this.$form.hasClass('js-credit-card-form') && !this.$form.hasClass('js-associate-form')){
      this.pubsub.publish('TO_IFRAME_GET_CC_DATA');
    } else {
      var dataParam = $.param(this.$form.find('input, select, textarea').serializeArray());
      this.submitButtonHandler(dataParam);
    }
  },
  setCCFrameData: function _setCCFrameData(ccFormData) {
    this.submitButtonHandler($.param(ccFormData));
    return true;
  },
  submitButtonHandler: function(dataParam) {    
    if($('.cn-form-switch').length){
      var cnFormVal = $('.cn-form-switch input:radio[name="cnForm"]:checked').val();
      dataParam = dataParam + '&cnForm=' + cnFormVal;
    }
    this.makeAjaxCall({
      method: this.$form.data('method'),
      url: this.$form.data('action'),
      data: dataParam,
      contentType: 'application/x-www-form-urlencoded',
      success: this.handleFormResponse.bind(this),
      error: this.handleFormResponse.bind(this)
    });
  },
  /**
   * @param  {Object} data : Response of AJAX call
   * This function is called on receiving the response from server after execution of AJAX call.
   */
  handleFormResponse: function(data) {
    var formData;
    if (data) {
      if (data.status === 'validation_error' || data.status === 'failure') {
        if(this.$form.hasClass('js-user-info-form')){
          this.pubsub.publish('USER_INFO_WIDGET_REFRESH');
        } else if(this.$form.hasClass('js-address-info-form')) {
          this.pubsub.publish('ADDRESS_INFO_WIDGET_REFRESH');
        } else if(this.$form.hasClass('js-credit-card-form')) {
          this.pubsub.publish('CREDIT_CARD_WIDGET_REFRESH');
        }
        this.$activeContainer.data('error', true);
        this.pubsub.publish('ERRORMSG_REFRESH');
      } else if(data.status === "success"){
        this.$activeContainer.data('error', false);
        this.pubsub.publish('REFRESH_ORG_BOOKING_DETAILS');
        if(this.$form.hasClass('js-user-info-form')){
          var formData = this.serializeFormData(this.$form.find('input, select, textarea'));
          if(this.isAssociate){
            this.changeGuestName(formData.firstName, formData.lastName);
          } else {
            this.changeGuestName(formData.firstName1, formData.lastName1);
          }
        }
        this.triggerWidgetCollapse(this.$activeContainer, false);
        this.refresh();
      }
    }
    this.$form.find('button[type="submit"]').prop('disabled', false);
    
  },
  changeGuestName: function(firstName, lastName){
    this.$activeContainer.closest('.js-accordion').find('.js-full-name').text(firstName+' '+ lastName);
  },

  creditCardModalPopUp: function _creditCardModalPopUp(data) {
    var _self = this;
    var creditCardPopUp = new Popup({
      url: data,
      sourceBlock: '.modal-content',
      alternateCloseMarkup: true,
      open: true
    });
    creditCardPopUp.register();
  }
});
